import logrocket from '@/services/logrocket';

import {
  fetchTypes as fetchTypesApi,
  fetchCountries as fetchCountriesApi,
  fetchIdentification as fetchIdentificationApi,
  updateIdentification as updateIdentificationApi
} from 'services/api/identification';

export const loadTypes = async () => {
  try {
    const { data } = await fetchTypesApi();
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const loadCountries = async () => {
  try {
    const { data } = await fetchCountriesApi();
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const loadIdentification = async () => {
  try {
    const { data } = await fetchIdentificationApi();
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const sendIdentification = async (payload) => {
  try {
    await updateIdentificationApi(payload);
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};
